import {
	Button,
	Col,
	Divider,
	Form,
	InputNumber,
	Row,
	Select,
	notification,
	Typography,
	Statistic,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
const { Text, Title } = Typography;

/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		disabled: true,
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Payment Price",
		dataIndex: "paymentPrice",
		key: "paymentPrice",
		disabled: true,
		render: (value) => {
			return (
				<Statistic
					valueStyle={{ fontSize: 14 }}
					precision={2}
					prefix={"$"}
					value={value}
				/>
			);
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const LogisticsRoute = (props) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [clientOptions, setClientOptions] = useState([]);
	const [mineOptions, setMineOptions] = useState([]);
	const [historyData, setHistoryData] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		Promise.all([getClients(), getMines()]).then(() => {
			getRoute();
		});
	}, []);

	const getClients = async () => {
		const url = api + "/logistics/client/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setClientOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getMines = async () => {
		const url = api + "/logistics/mine/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setMineOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getRoute = async () => {
		const url = api + "/logistics/route/get/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				setInitialValues({
					...initialValues,
					origin: data.payload.origin,
					destination: data.payload.destination,
					paymentPrice: data.payload.paymentPrice,
				});

				let history = [];
				data.payload.paymentPriceHistory.map((item, key) => {
					history.push({
						key: key,
						date: Intl.DateTimeFormat("en-US", {
							month: "numeric",
							year: "numeric",
							day: "numeric",
							hour: "2-digit",
							minute: "2-digit",
							second: "2-digit",
						}).format(new Date(item.createdAt)),
						paymentPrice: item.paymentPrice,
						user: item.updatedBy.name,
					});
				});
				setHistoryData(history);
			} else {
				openNotification("error", "Error", data.message);
			}

			setLoadingForm(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get route");
			console.error(err.message);
			return null;
		}
	};

	const updateRoute = async (data) => {
		const route = {
			paymentPrice: data.paymentPrice,
			origin: data.origin,
			destination: data.destination,
		};

		try {
			let url = api + "/logistics/route/update/" + props.match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, route);
			if (data.success) {
				openNotification("success", "Success", "Route updated");
				setTimeout(() => {
					setLoading(false);
					props.history.push("/logistics/route/list");
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update route");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		updateRoute(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Origin"
							name="origin"
							rules={[
								{
									required: true,
									message: "Please select a origin",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select origin`}
								size="large"
								options={mineOptions}
								style={{
									width: "100%",
								}}
								disabled
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Destination"
							name="destination"
							rules={[
								{
									required: true,
									message: "Please select a destination",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select destination`}
								size="large"
								options={clientOptions}
								style={{
									width: "100%",
								}}
								disabled
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Payment Price"
							name="paymentPrice"
							rules={[
								{
									required: true,
									message: "Payment Price must be filled",
								},
							]}
						>
							<InputNumber size="large" style={{ width: "100%" }} />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Title level={3}>History</Title>
				<CustomTable columns={columns} data={historyData} isScroll={false} />
				<Divider />
				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Logistics Route"
			description="Edit Logistics Route"
			type="medium"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default LogisticsRoute;
